import React from 'react'
import DeliveredPhotos from 'components/shared/DeliveredPhotos'
import DefaultProductStatus from '../../DefaultProductStatus'

const AreaPhotoProduct = ({match, product}) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredPhotos
        estateId={match.params.estateId}
        product={product}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

export default AreaPhotoProduct
